import {useMutation} from '@tanstack/react-query';
import {usePressReleaseQuery} from '../queries/use-press-release-query';
import {postTestMail} from '../../../../api/operations/post-test-mail';

export function usePostTestMailMutation() {
  const pressReleaseQuery = usePressReleaseQuery();

  const mutation = useMutation({
    async mutationFn(parameters: {
      mailTitle: string | null;
      mailTitlePrefixCompanyNameFlg: boolean;
      bodyHeadText: string | null;
      email: string;
    }) {
      if (pressReleaseQuery.data === undefined) return;

      const {companyId, releaseId} = pressReleaseQuery.data;
      await new Promise<void>((resolve) => {
        setTimeout(resolve, 1000);
      });

      return postTestMail({
        ...parameters,
        companyId,
        releaseId,
      });
    },
  });

  return mutation;
}
